import { Card } from '../../components/Card/Card';
import { useDebts } from '../../store/queryHooks';
import { kr } from '../../lib/format';
import styles from './GaeldPage.module.css';

export function GaeldPage() {
  const debts = useDebts();
  if (debts.isPending) return <div>Indlæser…</div>;
  if (debts.isError) return <div>Kunne ikke hente gæld.</div>;
  const list = debts.data ?? [];
  const total = list.reduce((s, d) => s + d.balance, 0);
  return (
    <Card className={styles.card}>
      <h2 className={styles.title}>Gæld</h2>
      <p className={styles.sub}>
        Boliglån, billån og anden gæld — så I har hele grundlaget samlet.
      </p>
      {list.length === 0 && (
        <div className={styles.empty}>Ingen gæld registreret. (Tilføj via API.)</div>
      )}
      {list.map((d) => (
        <div key={d.id} className={styles.row}>
          <div className={styles.left}>
            <div className={styles.name}>{d.name}</div>
            <div className={styles.subInfo}>
              {d.sub}
              {d.interest_rate !== null && ` · rente ${d.interest_rate.replace('.', ',')} %`}
            </div>
          </div>
          <div className={styles.balance}>{kr(d.balance)}</div>
        </div>
      ))}
      {list.length > 0 && (
        <div className={styles.total}>
          <span className={styles.totalLabel}>Samlet gæld</span>
          <span className={styles.totalValue}>{kr(total)}</span>
        </div>
      )}
    </Card>
  );
}
